import React, { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

const cardBase =
  "rounded-xl p-5 flex flex-col gap-3 border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] hover:shadow-[0_0_20px_#00ff9044] transition-shadow";

const SEVERITY_CONFIG = {
  urgent: { icon: "🚨", color: "text-red-400", bg: "bg-red-500/10 border-red-500/20" },
  warning: { icon: "⚠️", color: "text-yellow-400", bg: "bg-yellow-500/10 border-yellow-500/20" },
  info: { icon: "ℹ️", color: "text-[#00ff90]", bg: "bg-[#00ff90]/10 border-[#00ff90]/20" },
  reminder: { icon: "🔔", color: "text-purple-400", bg: "bg-purple-500/10 border-purple-500/20" },
};

const AlertItem = ({ alert }) => {
  const isObj = typeof alert === "object" && alert !== null;
  const message = isObj ? alert.message : alert;
  const severity = isObj ? (alert.severity || "info") : "info";
  const time = isObj ? alert.time : null;
  const cfg = SEVERITY_CONFIG[severity] || SEVERITY_CONFIG.info;

  return (
    <li className={`flex items-start gap-2 rounded-lg px-3 py-2 border ${cfg.bg}`}>
      <span className="text-sm shrink-0 mt-0.5">{cfg.icon}</span>
      <div className="min-w-0">
        <p className={`text-sm ${cfg.color}`}>{message}</p>
        {time && <p className="text-xs text-white/20 mt-0.5">{time}</p>}
      </div>
    </li>
  );
};

const AlertsAndReminders = ({ managerId }) => {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`${API_BASE}/api/manager/alerts?manager_id=${managerId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => { if (!res.ok) throw new Error("Failed to load alerts"); return res.json(); })
      .then((data) => setAlerts(data.alerts || []))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [managerId]);

  const urgentCount = alerts.filter((a) => typeof a === "object" && a.severity === "urgent").length;

  return (
    <div className={cardBase}>
      <div className="flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest">Alerts & Reminders</span>
        <span className="text-2xl">🔔</span>
      </div>

      {urgentCount > 0 && (
        <span className="self-start text-xs text-red-400 bg-red-500/10 border border-red-500/20 px-2 py-0.5 rounded-full">
          {urgentCount} urgent
        </span>
      )}

      {loading && <p className="text-white/20 text-sm animate-pulse">Loading...</p>}
      {error && <p className="text-red-400 text-sm">⚠ {error}</p>}

      {!loading && !error && (
        <ul className="space-y-2 max-h-48 overflow-y-auto pr-1">
          {alerts.length > 0 ? alerts.map((a, i) => <AlertItem key={i} alert={a} />) : (
            <li className="text-white/20 text-sm">No current alerts.</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default AlertsAndReminders;